export * from "./RegularTelephone";
